import React, { useEffect, useState } from 'react';

const QuantityInput = ({
  value,
  onChange = () => {}, 
  onBlur,
  onRemove,
  className = 'quantity-input',
  style,
  theme
}) => {
  const [inputValue, setInputValue] = useState(value);
  
  useEffect(() => {
    setInputValue(value);
  }, [value]);
  
  const defaultStyles = {
    border: theme ? `1px solid ${theme.primaryFontColor}` : '1px solid #333',
    color: theme?.primaryFontColor || 'black',
    ...style
  };

  const handleChange = (e) => {
    const val = e.target.value;
    setInputValue(val);
    onChange(val); 
  };

  const handleBlur = (e) => {
    const val = e.target.value;
    
    if (val === '' || parseInt(val, 10) <= 0) {
      if (onRemove) onRemove();
    } else {
      const numVal = parseInt(val, 10);
      if (!isNaN(numVal)) {
        if (onBlur) onBlur(numVal);
      } else {
        if (onBlur) onBlur(1);
      }
    }
  };

  const handleWheel = (e) => {
    e.target.blur();
  };

  return (
      <input
        type="text"
        value={inputValue}
        onChange={handleChange}
        onBlur={handleBlur}
        onWheel={handleWheel}
        className={className}
        style={defaultStyles}
      />
  );
};

export default QuantityInput;